import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { AxiosPromise } from 'axios';

export class CotizadorService {
  axios: AxiosVue;

  constructor() {
    this.axios = new AxiosVue(ServicioProxy.Metabase);
  }

  getEjecutivos(userId: string): AxiosPromise {
    return this.axios.http.post(
      'Metabase/PostgenericA/sucursal_virtual_cotizador/getEjecutivos',
      { userId: userId }
    );
  }

  getCotizaciones(clientId: string, body: any): AxiosPromise {
    return this.axios.http.post(
      'Metabase/PostgenericA/sucursal_virtual_cotizador/getCotizaciones',
      {
        clientId: clientId || '',
        data: body || '',
      }
    );
  }

  exportCuadratura(clientId: string, userId: string, body: any): AxiosPromise {
    return this.axios.http.post(
      'Metabase/PostgenericA/sucursal_virtual_cotizador/export',
      {
        clientId: clientId || '',
        userId: userId || '',
        body: body || '',
      }
    );
  }

  getClients(): AxiosPromise {
    return this.axios.http.post(
      'Metabase/PostgenericA/sucursal_virtual_cotizador/getClients',
      {}
    );
  }

  getSoluciones(): AxiosPromise {
    return this.axios.http.post(
      'Metabase/PostgenericA/sucursal_virtual_cotizador/getSoluciones',
      {}
    );
  }

  getDataContacto(rut: string): AxiosPromise {
    return this.axios.http.post(
      'Metabase/PostgenericA/sucursal_virtual_cotizador/getDataContacto',
      {
        rut_cliente: rut || '',
      }
    );
  }

  getCotizacion(id_cotizacion: string): AxiosPromise {
    return this.axios.http.post(
      'Metabase/PostgenericA/sucursal_virtual_cotizador/getCotizacion',
      {
        id_cotizacion: id_cotizacion || '',
      }
    );
  }

  saveCotizacion(clientId: string, body: any): AxiosPromise {
    return this.axios.http.post(
      'Metabase/PostgenericA/sucursal_virtual_cotizador/saveCotizacion',
      {
        clientId: clientId || '',
        data: body || '',
      }
    );
  }

  sendCotizacion(id_cotizacion: string): AxiosPromise {
    return this.axios.http.post(
      'Metabase/PostgenericA/sucursal_virtual_cotizador/sendCotizacion',
      {
        id_cotizacion: id_cotizacion || '',
      }
    );
  }

  ResendCotizacion(id_cotizacion: string): AxiosPromise {
    return this.axios.http.post(
      'Metabase/PostgenericA/sucursal_virtual_cotizador/ResendCotizacion',
      {
        id_cotizacion: id_cotizacion || '',
      }
    );
  }

  getPDFContactos(id_cotizacion: string): AxiosPromise {
    return this.axios.http.post(
      'Metabase/PostgenericA/sucursal_virtual_cotizador/get_pdfContactos',
      {
        id_cotizacion: id_cotizacion || '',
      }
    );
  }

  EnviarCotizador(
    id_cotizacion: string,
    endpoint: string,
    clientId: string,
    userId: string
  ): AxiosPromise {
    return this.axios.http.post(
      'Metabase/PostgenericA/sucursal_virtual_cotizador/EnviarCotizador',
      {
        id_cotizacion: id_cotizacion || '',
        endpoint: endpoint || '',
        clientId: clientId || '',
        userId: userId || '',
      }
    );
  }
}
